import React, { useRef, useEffect, useState } from "react";
import "../Serve/Serve.css";

const services = [
  { video: "/birthday.mp4", title: "Birthday Events ", description: "Celebrate birthdays with unforgettable experiences." },
  { video: "/wedding.mp4", title: "Wedding Events ", description: "Make your special day truly magical." },
  { video: "/cevent.mp4", title: "Corporate Events ", description: "Professional and seamless event execution." },
  { video: "/concernt.mp4", title: "Concerts Events ", description: "Energetic and vibrant live experiences." },
  { video: "/ring.mp4", title: "Engagements Events ", description: "Cherish moments that matter most." },
  { video: "/event.mp4", title: "Full Event Management", description: "From planning to execution, we've got you covered." },
];

const serveTextArray = [
  " ★ Live Concerts ★ Corporate Events ★ Wedding Events ★ Social Events",
  " ★ Live Concerts ★ Corporate Events ★ Wedding Events ★ Social Events",
  " ★ Live Concerts ★ Corporate Events ★ Wedding Events ★ Social Events",
  " ★ Live Concerts ★ Corporate Events ★ Wedding Events ★ Social Events",
];

// LazyVideo component - loads video src only when visible
const LazyVideo = ({ src, className, ...props }) => {
  const videoRef = useRef();
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.disconnect();
        }
      },
      {
        rootMargin: "100px",
      }
    );

    if (videoRef.current) {
      observer.observe(videoRef.current);
    }

    return () => observer.disconnect();
  }, []);

  return (
    <video
      ref={videoRef}
      src={isVisible ? src : undefined}
      preload="none"
      autoPlay={isVisible}
      loop={isVisible}
      muted
      playsInline
      className={className}
      {...props}
    />
  );
};

const Serve = () => {
  return (
    <section className="serve">
      <div className="serve-heading-wrapper">
        <div className="serve-heading">
          {serveTextArray.map((text, index) => (
            <span key={index} className="serve-text">
              {text.split("★").map((segment, i) => (
                <React.Fragment key={i}>
                  {i > 0 && <span className="rotating-star">★</span>}
                  {segment}
                </React.Fragment>
              ))}
            </span>
          ))}
        </div>
      </div>

      <div className="serve-grid">
        {services.map((service, index) => (
          <div className="serve-card" key={index}>
            <span className="services-tag">{service.title}</span>
            <LazyVideo src={service.video} className="serve-video" />
            <div className="overlay-s">
              {/* <h2>{service.title}</h2> */}
              <p>{service.description}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Serve;
